<div class="container-grid">
    <mat-grid-list  [cols]="breakpoint" rowHeight="300px" (window:resize)="onResize($event)">
        <mat-grid-tile *ngFor="let service of services;">
            <app-service-card [service]="service"></app-service-card>
        </mat-grid-tile>
    </mat-grid-list>    
</div>
